import { createTrackingConfig } from '../../components/generic/labels';
import { getDateFormat, tableConfig, uiConfig } from '../../config/appConfig';

export const manualTypeConfig = {
  entityName: 'Manual Type',
  entityTypeId: null,

  api: {
    baseEndpoint: '/manual-type',
    endpoints: {
      list: '',
      create: '',
      update: (id) => `/${id}`,
      delete: (id) => `/${id}`,
      getById: (id) => `/${id}`,
      bulkDelete: '/bulk-delete',
    },
    lookupEndpoints: {},
    swrInvalidation: { mainList: '/manual-type' },
  },

  ui: {
    drawerWidth: '30%',
    defaultPageSize: tableConfig.defaultPageSize,
    pageSizeOptions: tableConfig.pageSizeOptions,
    defaultTableDensity: tableConfig.defaultDensity,
    requiredFieldStyle: uiConfig.requiredFieldStyle,
    tableVariant: 'default',
    splitView: true,
    searchInputMaxWidth: uiConfig.searchInputMaxWidth,
  },

  features: { fileAttachments: false },

  displayName: 'Manual Type Management',
  description: 'Classification types for manuals (multi-select on each manual)',
  icon: 'M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z',

  fieldsToRemove: [
    'creator',
    'updater',
    'createdAt',
    'updatedAt',
    'createdBy',
    'updatedBy',
    'links',
  ],

  fields: [
    { name: 'id', label: 'ID', type: 'hidden', table: false, filterable: false },
    {
      name: 'typeName',
      label: 'Type Name',
      type: 'text',
      required: true,
      placeholder: 'e.g. Safety',
      table: { header: 'Type Name', width: '220px', sortable: true },
      filterable: true,
      validation: {
        required: true,
        minLength: 2,
        maxLength: 255,
      },
    },
    {
      name: 'typeCode',
      label: 'Type Code',
      type: 'text',
      required: false,
      placeholder: 'e.g. SAF',
      table: { header: 'Code', width: '120px', sortable: true },
      filterable: true,
      validation: { maxLength: 50 },
    },
    {
      name: 'createdAt',
      label: 'Created',
      type: 'date',
      readOnly: true,
      table: {
        header: 'Created',
        width: tableConfig.dateColumnWidth,
        sortable: true,
        cellRenderer: 'date',
        dateFormat: getDateFormat('table'),
      },
      filterable: true,
      filterType: 'dateRange',
    },
  ],

  get tableColumns() {
    return this.fields
      .filter((field) => field.table !== false && field.table)
      .map((field) => ({
        key: field.table.displayField || field.name,
        header: field.table.header || field.label,
        width: field.table.width || 'auto',
        sortable: field.table.sortable !== false,
        displayField: field.table.displayField || field.name,
        cellRenderer: field.table.cellRenderer || 'default',
        originalField: field.name,
      }));
  },

  exportFileName: 'manual_types',

  get filterableFields() {
    return this.fields.filter((f) => f.filterable).map((f) => f.name);
  },

  filterGroups: [
    { name: 'basic', label: 'Basic', icon: '🔍', fields: ['typeName', 'typeCode'] },
  ],

  formSections: [
    {
      title: 'Type',
      icon: '🏷️',
      layout: 'grid',
      gridCols: 'md:grid-cols-2',
      fields: ['typeName', 'typeCode'],
    },
  ],

  trackingSection: createTrackingConfig('Manual Type'),

  labels: {
    singular: 'Manual Type',
    plural: 'Manual Types',
    pageTitle: 'Manual Types',
    pageSubtitle: 'Types available when classifying manuals',
    searchPlaceholder: 'Search manual types...',
    viewTitle: 'View Manual Type',
    noSelectionText: 'Select a manual type',
  },
};

export default manualTypeConfig;
